<template>
  <div>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-layout justify-center align-start>
          <v-flex>
            <message-iframe
              ref="iframe"
              @message="receiveMessage"
              v-if="!overlay"
              :fullscreen="true"
              :src="src"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import MessageIframe from "dev/components/MessageIframe";
import { types as GameTypes } from "dev/store/modules/Game.module";
import { types as GameLogTypes } from "dev/store/modules/GameLog.module";
import GameDataService from "dev/services/GameDataService";

export default {
  name: "play-view",
  props: [],
  components: { MessageIframe },
  data() {
    return {
      overlay: true,
      game: null,
      gameData: {}
    };
  },
  computed: {
    src() {
      return `https://closeapp.co.il/apps/pash/games/indexEditMode.html${location.search ||
        "?a=1"}&game=true&key=1`;
      // return "http://shabat.test/indexEditMode.html?game=true&key=1";
    },
    isManager() {
      return this.$store.getters.isManager;
    }
  },
  methods: {
    receiveMessage(event) {
      if (event.action) this[event.action]();
    },
    iframeReady() {
      this.$refs.iframe.postMessageCustom({
        action: "getJson",
        json: this.gameData
      });
    }
  },
  watch: {},
  async created() {
    try {
      await this.$store.dispatch(GameTypes.GET, this.$route.params.id);
      this.gameData = await GameDataService.get(this.$route.params.id);
      /*not count managers play*/
      if (!this.isManager) {
        setTimeout(() => {
          const gameLog = { game_id: this.$route.params.id };
          this.$store.dispatch(GameLogTypes.SAVE, gameLog);
        }, 10000);
      }
      this.overlay = false;
    } catch (e) {
      await swal.fire({
        title: "ללא הרשאות גישה",
        text: "אנא פנה למנהל המערכת",
        type: "error",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "אישור",
        showCancelButton: false
      });
    }
  },
  mounted() {}
};
</script>

<style scoped></style>
